// extracted by mini-css-extract-plugin
export var cards = "mapCard-module--cards--60b35";
export var icon = "mapCard-module--icon--50258";
export var line = "mapCard-module--line--447d2";
export var open = "mapCard-module--open--3c059";
export var placeholder = "mapCard-module--placeholder--47d8c";
export var tab = "mapCard-module--tab--0973f";
export var wrapper = "mapCard-module--wrapper--feccc";